import { render } from "./MarketingComponent.vue?vue&type=template&id=d7ce56fa"
import script from "./MarketingComponent.vue?vue&type=script&lang=js"
export * from "./MarketingComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__